import React from 'react';
import PropTypes from 'prop-types';
import { useData, useTexts } from '../data';

const DonorCard = ({ donor, index }) => {
  const { time } = useData();
  const TEXTS = useTexts();

  return (
    <div
      key={donor.donorId || index}
      className="col-12 mb-3"
      data-component="DonorCard"
    >
      <div
        className="card h-100 shadow-sm"
        style={{ border: '1px solid #e0e0e0' }}
      >
        <div className="card-body p-3">
          <div className="border border-success bg-success bg-opacity-10 p-2 mb-3 rounded">
            <span className="text-success fw-bold">{TEXTS.DONOR_ID}</span>
            <span className="text-dark fw-bold ms-1">{donor.donorId}</span>
          </div>

          <h6 className="fw-bold text-dark mb-3">
            {donor.donorNameTamil}, {donor.pincode}
          </h6>

          {time.currentStatus >= 3 && donor.pageNumber !== '' && (
            <div className="border border-primary bg-primary bg-opacity-10 p-2 mb-3 rounded">
              <span className="text-primary fw-bold">{TEXTS.PAGE_NUMBER}</span>
              <span className="text-dark fw-bold ms-1">{donor.pageNumber}</span>
            </div>
          )}

          <div className="text-dark">
            {donor.featuredLocalityTamil !== '' && (
              <div className="mb-2">
                <strong className="color">{TEXTS.LOCALITY}</strong>{' '}
                {donor.featuredLocalityTamil}
              </div>
            )}

            <div className="mb-2">
              <strong className="color">{TEXTS.PHONE}</strong>{' '}
              {donor.phone !== '' ? donor.phone : TEXTS.DASH}
            </div>

            {donor.donatedProduct && (
              <div className="mb-2">
                <strong className="color">{TEXTS.DONATION_ITEM}</strong>{' '}
                {donor.donatedProduct}
              </div>
            )}

            {donor.fullAddress !== '' && (
              <div className="mb-2">
                <strong className="color">{TEXTS.POSTAL_ADDRESS}</strong>
                <br />
                <span className="text-dark">{donor.fullAddress}</span>
              </div>
            )}

            <div className="mt-3">
              {donor.isPostalSent && !donor.isLocalDonor ? (
                <>
                  {time?.currentStatus == 5 ? (
                    <div className="border border-success bg-success bg-opacity-10 p-2 rounded">
                      <span className="text-success fw-bold">
                        {TEXTS.POSTAL_SENT}
                      </span>
                    </div>
                  ) : (
                    <div className="border border-info bg-info bg-opacity-10 p-2 rounded">
                      <span className="text-info fw-bold">
                        {TEXTS.POSTAL_SOON}
                      </span>
                    </div>
                  )}
                </>
              ) : (
                <div className="border border-danger bg-danger bg-opacity-10 p-2 rounded">
                  <span className="text-danger fw-bold">
                    {time?.currentStatus < 3
                      ? TEXTS.POSTAL_WILL_NOT_SENT
                      : TEXTS.POSTAL_NOT_SENT}
                  </span>
                </div>
              )}

              {donor.isLocalDonor && (
                <div className="bg-light p-2 rounded mt-2">
                  <small className="text-secondary">
                    {TEXTS.LOCAL_DONOR_REASON}
                  </small>
                </div>
              )}

              {!donor.isPostalSent &&
                donor.postalReasons.map((reason, idx) => (
                  <div key={idx} className="bg-light p-2 rounded mt-2">
                    <small className="text-dark">
                      <strong className="color">{TEXTS.REASON}</strong>{' '}
                      {reason.reason}
                      <br />
                      <strong className="color">
                        {TEXTS.REJECTED_DATE}
                      </strong>{' '}
                      {reason.rejectedDate}
                    </small>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DonorCard.propTypes = {
  donor: PropTypes.shape({
    donorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    donorNameTamil: PropTypes.string,
    featuredLocalityTamil: PropTypes.string,
    pincode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    phone: PropTypes.string,
    donatedProduct: PropTypes.string,
    fullAddress: PropTypes.string,
    isPostalSent: PropTypes.bool,
    isLocalDonor: PropTypes.bool,
    postalReasons: PropTypes.array,
    pageNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  index: PropTypes.number.isRequired,
};

export default DonorCard;
